import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCountryList, updateCountryList } from "../../../slices/LocationSlice/countrySlice"
import {fetchOptionListData} from "../../../slices/LocationSlice/optionSlice";
import Pagination from "../../../components/Pagination";
import Loader from "../../../components/Loader";
import EditableTable from "./CountryTable";
import Modal from "../../../components/Modal"
import ChangeLog from "../../../components/ChangeLog";
import { fetchLanguageList } from "../../../slices/panelSlice/languageSlice";
import AddCountry from "./AddCountry"
import SearchTable from "../../../components/SearchTable";



function Country({editable}) {

  const dispatch = useDispatch();

  const { countryList, status } = useSelector((state) => state.countryList);
  const { data, error } = useSelector((state) => state.language);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(countryList?.result) ? countryList?.result?.slice(indexOfFirstItem, indexOfLastItem) : [];
  const totalPages = Array.isArray(countryList?.result) ? Math.ceil(countryList?.result?.length / itemsPerPage) : 0;
  const headers = countryList?.result?.length > 0 ? Object.keys(countryList.result[0]).filter((key) => key !== 'id') : [];
  const editableFields = ['title','status','code','val','optionType']; // Define editable fields

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog,setCurrentLog] = useState([]);
  const [addCountryModal, setAddCountryModal] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const { optionList } = useSelector((state) => state.option);
  const [searchQuery, setSearchQuery] = useState("")
  const [filteredRows, setFilteredRows] = useState(currentItems);

  useEffect(() => {
    if(status==="idle"){
      dispatch(fetchLanguageList())
      dispatch(fetchCountryList());
      dispatch(fetchOptionListData());
    }

  }, [dispatch]);



  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = countryList.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };


  const handleSave = async () => {
    const { id, title,code,optionType,val,status} = editedData;
    const optionId = optionList?.result?.filter(f=>f.title===optionType)[0]?.id;
    const updatedData = { id, title, code, optionType:optionId,val,status };
    console.log(updatedData)
    const resp = await dispatch(updateCountryList(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchCountryList());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field,val) => {
      if(['status','active'].includes(field)){
        setEditedData((prev) => ({
          ...prev,
          [field]:!val,
        }));
      }else{
        setEditedData((prev) => ({
          ...prev,
          [field]:e.target.value,
        }));
      }
  };

  const handleLog = (id)=>{
    const logData = countryList.Change_Log.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }


  return (
    <div className="w-full flex items-center justify-end flex-col">
<div className="w-11/12 flex justify-end">
<SearchTable
            placeholder="Search for a country..."
            data={currentItems}
            onSearchResults={setFilteredRows} // Update filtered list in parent
            className='m-2'
            allData={countryList?.result}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />

</div>

<div className="max-w-full overflow-scroll">
<EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
        optionList={optionList}
        languageList={data?.result}
        filteredRows={filteredRows}
        editable={editable}
      />
</div>

     
      
      <div className="flex mt-4 items-center justify-between w-11/12">

{searchQuery.length < 3 && <Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>}


{editable && <button className="activeBtn text-sm text-white  py-1 px-2 rounded" onClick={()=>setAddCountryModal(true)}>
      + Add Country
</button>}

    </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />


     <Modal
        isOpen={addCountryModal}
        onClose={()=>setAddCountryModal(false)}
        title="Add Country"
        content={<AddCountry  optionList={optionList}/>}
      />



    </div>
  );
}

export default Country;